import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HttpService } from 'src/app/shared/services/http.service';
import { DeleteWarningComponent } from '../../delete-warning/delete-warning.component';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { ExcelToTableComponent } from '../../excel-to-table/excel-to-table.component';
import * as XLSX from 'xlsx';
import { TableService } from 'src/app/shared/services/tableService/table.service';
import { FTL_order } from 'src/app/shared/interfaces/rate-information.interface';

@Component({
  selector: 'app-ftl-matrix',
  standalone: false,
  templateUrl: './ftl-matrix.component.html',
  styleUrl: './ftl-matrix.component.scss',
})
export class FtlMatrixComponent implements OnChanges {
  truckType = ['euro', 'mega', 'jumbo', 'giga'];
  dbDataSource: any;
  dataSource: any = [];
  displayedCol = [
    'from',
    'to',
    'euro-inbound',
    'euro-return',
    'euro-roundtrip',
    'mega-inbound',
    'mega-return',
    'mega-roundtrip',
    'jumbo-inbound',
    'jumbo-return',
    'jumbo-roundtrip',
    'giga-inbound',
    'giga-return',
    'giga-roundtrip',
  ]; //
  destinCol: string[] = [];
  rateTypeMapping: any = {};
  selectTruckType: string[] = [];
  surchargeArr: any;
  mautchargeArr: any;

  //   "EURO - SINGLE TRIP INBOUND km rate": "euro-inbound",
  //   "EURO - SINGLE TRIP RETURN km rate": "euro-return",
  //   "EURO - ROUNDTRIP km rate": "euro-round trip",
  //   "MEGA - SINGLE TRIP INBOUND km rate": "mega-inbound",
  //   "MEGA - SINGLE TRIP RETURN km rate": "mega-return",
  //   "MEGA - ROUNDTRIP km rate": "mega-round trip",
  //   "JUMBO - SINGLE TRIP INBOUND km rate": "jumbo-inbound",
  //   "JUMBO - SINGLE TRIP RETURN km rate": "jumbo-return",
  //   "JUMBO - ROUNDTRIP km rate": "jumbo-round trip",
  //   "GIGA - SINGLE TRIP INBOUND km rate": "giga-inbound",
  //   "GIGA - SINGLE TRIP RETURN km rate": "giga-return",
  //   "GIGA - ROUNDTRIP km rate": "giga-round trip"
  // };

  @Input() rateId: number = 0;
  @Input() name: string = 'ftl Table';
  @Input() orderId: number = 0;
  @Input() operation: string = 'add';
  userData: any;
  curentSelectedVal: any;
  rateRatio: any;

  constructor(
    private httpService: HttpService,
    private dialog: MatDialog,
    public appService: AppService,
    private tableService: TableService
  ) {
    this.deleteIconUpdate();
    let userData = sessionStorage.getItem('user-data');
    this.userData = userData ? JSON.parse(userData) : null;
    this.appService.matrixDataEmit.subscribe((evt: any) => {
      if (evt.type == 42) {
        this.rateId = evt.id;
        this.getTableData();
        this.getCountryList();
      }
    });
    this.appService.ftlRateChangeSub?.unsubscribe();
    this.appService.ftlRateChangeSub =
      this.appService.applyCahngeEmitForFTL.subscribe((evt: any) => {
        if (
          this.appService.rateTableList[this.appService.selectedItem]
            ?.RateTableTypeID === 42
        ) {
          this.rateRatio = evt;
          this.onCalculateRatio();
        }
      });
  }

  onCalculateRatio() {
    this.appService.onRAvalueChanged = true;
    let truckList = this.truckType.filter(
      (type: string) => !this.selectTruckType.includes(type)
    );
    this.dbDataSource.forEach((obj: any) => {
      truckList.forEach((i: any) => {
        if (
          obj[i + '-inbound'] !== null ||
          obj[i + '-return'] !== null ||
          obj[i + '-roundtrip'] !== null
        ) {
          obj[i + '-inbound'] =
            Number(obj[i + '-inbound']) === 0
              ? 0
              : +(
                  Number(obj[i + '-inbound']) +
                  (Number(obj[i + '-inbound']) * this.rateRatio) / 100
                ).toFixed(2);
          obj[i + '-return'] =
            Number(obj[i + '-return']) === 0
              ? 0
              : +(
                  Number(obj[i + '-return']) +
                  (Number(obj[i + '-return']) * this.rateRatio) / 100
                ).toFixed(2);
          obj[i + '-roundtrip'] =
            Number(obj[i + '-roundtrip']) === 0
              ? 0
              : +(
                  Number(obj[i + '-roundtrip']) +
                  (Number(obj[i + '-roundtrip']) * this.rateRatio) / 100
                ).toFixed(2);

          if (this.rateRatio < 0) {
            obj[i + '-inbound'] = Math.max(obj[i + '-inbound'], 0);
            obj[i + '-return'] = Math.max(obj[i + '-return'], 0);
            obj[i + '-roundtrip'] = Math.max(obj[i + '-roundtrip'], 0);
          }
        }
      });
    });
    this.onSave();
  }

  getCountryList() {
    this.appService.isLoading = true;
    this.httpService.getCountryList().subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.appService.countryListArr = res;
      }
    });
  }

  formatElementData(val: any) {
    return val != null ? '' + Number(val).toFixed(2) : '';
  }

  deleteIconUpdate() {
    this.destinCol = [];
    this.displayedCol.forEach((col) => {
      if (['from', 'to'].includes(col)) {
        if (!this.destinCol.includes('Distance'))
          this.destinCol.push('Distance');
      } else {
        if (!this.destinCol.includes(col.split('-')[0])) {
          this.destinCol.push(col.split('-')[0]);
          this.destinCol.push(`${col.split('-')[0]}-del`);
        }
      }
    });

    const sortedArray = this.destinCol.sort((a, b) => {
      const indexA = this.truckType.indexOf(a.split('-')[0]);
      const indexB = this.truckType.indexOf(b.split('-')[0]);

      return indexA - indexB;
    });
    this.destinCol = sortedArray;
    this.selectTruckType = this.truckType.filter(
      (value) => !this.destinCol.includes(value)
    );
    let outputOrder = [];

    for (let i = 0; i < this.destinCol.length; i++) {
      if (this.destinCol[i] === 'Distance') {
        outputOrder.push('from', 'to');
      } else if (this.destinCol[i].includes('del')) {
        let k = this.destinCol[i].split('-')[0];
        outputOrder.push(k + '-inbound', k + '-return', k + '-roundtrip');
      }
    }
    this.displayedCol = outputOrder;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rateId']?.currentValue) {
      this.rateId = changes['rateId'].currentValue;
    }
    if (changes['name']?.currentValue) {
      this.name = changes['name'].currentValue;
    }
    if (changes['operation']?.currentValue) {
      this.operation = changes['operation'].currentValue;
    }
    if (changes['orderId']?.currentValue) {
      this.orderId = changes['orderId'].currentValue;
    }

    this.getTableData();
  }

  getTableData() {
    if (this.appService.rateBackUpData[this.appService.selectedItem]) {
      this.dbDataSource =
        this.appService.rateBackUpData[this.appService.selectedItem];
      let res = this.appService.rateDateSource[this.appService.selectedItem];

      let getCol = Object.keys(this.dbDataSource[0]);
      // getCol = ['from','to'].concat(getCol)
      this.displayedCol = getCol;
      this.deleteIconUpdate();
      this.curentSelectedVal = res;

      let mautCountry = res.CountryID?.split(',');
      let mautCountryCost: any = ('' + res.MautCost)?.split(',');
      let mautOutArr: any = [];
      if (mautCountry && mautCountry.length > 0) {
        mautOutArr = mautCountry.map((item: any, index: any) => ({
          country: this.appService.countryListArr.find(
            (i: any) => i.CountryID === +item
          )?.CountryName,
          rate: '' + mautCountryCost[index],
        }));
        this.appService.mautCostEmit.emit(mautOutArr); // chnaginf for just fix
      }

      let additionalCosts = ('' + res.AdditionalCost)?.split(',');
      let additionalCostItems = res.AdditionalCostItem?.split(',');
      let costOutarr: any = [];
      if (additionalCostItems && additionalCostItems.length > 0) {
        costOutarr = additionalCostItems.map((item: any, index: any) => ({
          charge: item,
          rate: additionalCosts[index],
        }));
      }
      this.appService.additionalCostEmit.emit(costOutarr);
      this.appService.mautCostEmit.emit(mautOutArr);

      return;
    }
    this.appService.isLoading = true;
    this.httpService.getFTLTable(this.rateId).subscribe((res: any) => {
      if (res) {
        this.dbExcelDataFormat(res);
      } else {
        this.appService.isLoading = false;
      }
    });
  }

  dbExcelDataFormat(res: any, fromExcel = false) {
    this.rateTypeMapping = {};
    // Step 1: Collect all unique rate types
    const uniqueRateTypes = new Set();
    res.forEach((obj: any) => {
      uniqueRateTypes.add(obj.TrailerRateType);
    });

    // Step 2: Map rate types to keys
    uniqueRateTypes?.forEach((rateType: any) => {
      let key = rateType
        .toLowerCase()
        .replace(/ - /g, '-')
        .replace(/ km rate/g, '')
        .replace(/ /g, '-');

      // Perform specific replacements
      key = key
        .replace('single-trip-inbound', 'inbound')
        .replace('single-trip-return', 'return')
        .replace('round-trip', 'roundtrip');
      this.rateTypeMapping[rateType] = key;

      this.displayedCol = ['from', 'to'].concat(
        Object.values(this.rateTypeMapping)
      );
      this.selectTruckType = this.truckType.filter(
        (value) =>
          !Object.values(this.rateTypeMapping).some((objValue: any) =>
            objValue.includes(value)
          )
      );
      this.deleteIconUpdate();
    });
    let mautData: any;
    if (!fromExcel) {
      this.curentSelectedVal = res[0];
      mautData = res[0]?.MautCountry
        ? this.appService.onMautcountry(
            res[0]?.MautCountryCost,
            res[0].MautCountry
          )
        : { cost: null, item: null };
    } else {
      // res[0].MautCountry = this.curentSelectedVal.MautCountry
      // res[0].MautCountryCost = this.curentSelectedVal.MautCountryCost
      if (
        this.appService.rateDateSource[this.appService.selectedItem]?.CountryID
      ) {
        let ids = this.appService.rateDateSource[this.appService.selectedItem]
          ?.CountryID
          ? this.appService.rateDateSource[
              this.appService.selectedItem
            ]?.CountryID.split(',').map((id: any) => parseInt(id.trim()))
          : '';
        res[0].MautCountry = this.appService.countryListArr
          .filter((i: any) => ids.includes(i.CountryID))
          .map((x: any) => x.CountryName)
          .join(',');
        res[0].MautCountryCost =
          this.appService.rateDateSource[this.appService.selectedItem].MautCost;
      } else {
        res[0].MautCountry = '';
        res[0].MautCountryCost = '';
      }
      res[0].AdditionalCostItem =
        this.surchargeArr.length > 0
          ? this.surchargeArr.map((obj: any) => Object.keys(obj)).join(',')
          : undefined;
      res[0].AdditionalCost =
        this.surchargeArr.length > 0
          ? this.surchargeArr.map((obj: any) => Object.values(obj)).join(',')
          : undefined;
      if (fromExcel) {
        // res[0].MautCountry = this.mautchargeArr.map((obj:any) => Object.keys(obj)).join(',');
        // res[0].MautCountryCost = this.mautchargeArr.map((obj:any) => Object.values(obj)).join(',')
      }
      this.appService.rateDateSource[
        this.appService.selectedItem
      ].AdditionalCost = this.surchargeArr
        .map((obj: any) => Object.values(obj))
        .join(',');
      this.appService.rateDateSource[
        this.appService.selectedItem
      ].AdditionalCostItem = this.surchargeArr
        .map((obj: any) => Object.keys(obj))
        .join(',');
      mautData = res[0]?.MautCountry
        ? {
            cost: this.appService.rateDateSource[this.appService.selectedItem]
              .MautCost,
            item: this.appService.rateDateSource[this.appService.selectedItem]
              .CountryID,
          }
        : { cost: null, item: null };
    }
    // mautData= res[0]?.MautCountry?{item:this.appService.rateDateSource[this.appService.selectedItem].CountryID, cost:this.appService.rateDateSource[this.appService.selectedItem].MautCost}:{cost:null,item:null};
    this.appService.rateDateSource[this.appService.selectedItem].MautCost =
      mautData?.cost;
    this.appService.rateDateSource[this.appService.selectedItem].CountryID =
      mautData?.item;
    const updatedArray = res.map((obj: any) => {
      const { Weight, FTLMatrixCost, MautCountryCost, ...rest } = obj;
      return {
        FTLWeight: Weight,
        FTLCost: FTLMatrixCost,
        MautCost: mautData.cost,
        CountryID: mautData.item,
        ...rest,
      };
    });
    this.appService.isLoading = false;
    this.appService.setRateTableData(updatedArray, this.orderId, 'ftl');
    const transformedArray = res.reduce((acc: any, obj: any) => {
      const weightRange = obj.Weight.split('-');
      const key = `${weightRange[0]}-${weightRange[1]}`;

      // Initialize the object with dynamic rate types if it doesn't exist
      if (!acc[key]) {
        acc[key] = {
          from: weightRange[0],
          to: weightRange[1],
        };
        uniqueRateTypes.forEach((rateType: any) => {
          acc[key][this.rateTypeMapping[rateType]] = 0;
        });
      }

      const rateTypeKey: any = this.rateTypeMapping[obj.TrailerRateType];
      if (rateTypeKey) {
        acc[key][rateTypeKey] = obj.FTLMatrixCost;
      }
      return acc;
    }, {});

    let finalArray = Object.values(transformedArray);
    this.dbDataSource = finalArray;

    if (this.dbDataSource.length)
      this.dbDataSource = this.dbDataSource.sort(
        (a: any, b: any) => Number(a.from) - Number(b.from)
      );
    this.appService.exportConversionEmitter.emit({
      data: this.dbDataSource,
      type: 'ftl',
    });
    this.appService.rateBackUpData[this.appService.selectedItem] =
      this.dbDataSource;

    if (!res[0]) {
      return;
    }
    // calculate addition cost
    let additionalCosts =
      this.rateId === 0 ? '' : ('' + res[0].AdditionalCost)?.split(',');
    let additionalCostItems =
      this.rateId === 0 ? '' : res[0].AdditionalCostItem?.split(',');
    if (fromExcel) {
      additionalCosts = res[0].AdditionalCost?.split(',');
      additionalCostItems = res[0].AdditionalCostItem?.split(',');
    }
    let costOutarr = [];
    // if(this.rateId !== 0){
    if (additionalCostItems && additionalCostItems.length > 0) {
      costOutarr = additionalCostItems.map((item: any, index: any) => ({
        charge: item,
        rate: additionalCosts[index],
      }));
    }

    // calculate maut cost
    let mautCountry = res[0].MautCountry?.split(',');
    let mautCountryCost: any = ('' + res[0].MautCountryCost)?.split(',');
    if (this.rateId === 0 && mautCountry?.length == 0) {
      mautCountryCost = [];
      mautCountryCost = Array.from({ length: mautCountry.length }).fill(0);
    }
    let mautOutArr = [];

    if (mautCountry && mautCountry.length > 0) {
      mautOutArr = mautCountry.map((item: any, index: any) => ({
        country: item,
        rate: mautCountryCost[index],
      }));
    }

    // if (!this.appService.rateBackUpData[this.appService.selectedItem]) {
    this.appService.additionalCostEmit.emit(costOutarr);
    this.appService.mautCostEmit.emit(mautOutArr);
    let obj = {
      data: this.dbDataSource,
      type: 'ftl',
      maut: mautOutArr,
      charge: costOutarr,
    };
    // this.appService.exportPDFTableList[this.appService.selectedItem] = obj

    // }
  }

  getColspan(i: any) {
    if (i.split('-')[1]) return 1;
    return 2;
  }

  updateRateTypeMapping() {
    let test: any = [];
    this.destinCol
      .filter((item: any) => item.includes('-del'))
      .map((item: any) => {
        let str = item.split('-')[0];
        test[
          `${str.toUpperCase() + ' - SINGLE TRIP INBOUND km rate'}`
        ] = `${str}-inbound`;
        (test[
          `${str.toUpperCase() + ' - SINGLE TRIP RETURN km rate'}`
        ] = `${str}-return`),
          (test[
            `${str.toUpperCase() + ' - ROUNDTRIP km rate'}`
          ] = `${str}-roundtrip`);
      });
    this.rateTypeMapping = test;
  }

  onValueCahnge(val: any, e: any, no: number) {
    this.appService.onRAvalueChanged = true;
    let cost: number = val.value;
    this.dbDataSource[no][e] = Number(cost);
    this.appService.rateBackUpData[this.appService.selectedItem] =
      this.dbDataSource;
    this.appService.exportConversionEmitter.emit({
      data: this.dbDataSource,
      type: 'ftl',
    });
    this.onSave();
  }

  getKeyByValue(
    object: { [key: string]: string },
    value: string
  ): string | undefined {
    return Object.keys(object).find((key) => object[key] === value);
  }

  onExportdata() {
    let arr = [
      { displayName: 'Km Band Min', name: 'from', order: 1 },
      { displayName: 'Km Band Max', name: 'to', order: 2 },
    ];
    this.destinCol
      .filter((item: any) => item.includes('-del'))
      .map((item: any) => {
        let str = item.split('-')[0];
        let count = arr.length;
        arr.push({
          displayName: `${
            str.toUpperCase() + ' - SINGLE TRIP INBOUND km rate'
          }`,
          name: `${str}-inbound`,
          order: count + 1,
        });
        arr.push({
          displayName: `${str.toUpperCase() + ' - SINGLE TRIP RETURN km rate'}`,
          name: `${str}-return`,
          order: count + 1,
        });
        arr.push({
          displayName: `${str.toUpperCase() + ' - ROUNDTRIP km rate'}`,
          name: `${str}-roundtrip`,
          order: count + 1,
        });
      });
    this.tableService.exportToExcel(this.dbDataSource, arr, this.name);
  }
  onSave() {
    this.updateRateTypeMapping();
    let getData = sessionStorage.getItem('user-data');
    let userData = getData ? JSON.parse(getData) : null;
    const originalArray = this.dbDataSource.flatMap((obj: any) => {
      const { from, to, ...weights } = obj;
      return Object.entries(weights).map(([weightRange, cost]) => ({
        FTLWeight: `${from}-${to}`,
        TrailerRateType: this.getKeyByValue(this.rateTypeMapping, weightRange),
        FTLCost: cost,
      }));
    });
    this.appService.setRateTableData(originalArray, this.orderId, 'ftl');
  }

  onImportData() {
    const dialogRef = this.dialog.open(ExcelToTableComponent, {
      disableClose: false,
      data: { screen: 'ftl' },
    });
    dialogRef.afterClosed().subscribe((evt) => {
      if (evt.operation === 'save' && evt.type === 'ftl') {
        this.appService.onRAvalueChanged = true;
        this.surchargeArr = evt.surcharge;
        this.mautchargeArr = evt.maut;
        this.dbExcelDataFormat(evt.data, true);
      } else if (evt.operation === 'error' && evt.type === 'ftl') {
        this.httpService.openSnackBar('Please Upload the Correct File');
      }
    });
  }

  dropDownSelct() {
    const dropDownElement = document.getElementById('ftl-drop-down');
    if (dropDownElement) {
      if (dropDownElement.style.display === 'block') {
        dropDownElement.style.display = 'none'; // If it's "block", make it "none"
      } else {
        dropDownElement.style.display = 'block'; // If it's "none" or anything else, make it "block"
      }
    }
  }

  onAddTrailer(i: string) {
    this.appService.onRAvalueChanged = true;
    if (
      this.displayedCol.includes(
        i + '-inbound' || i + '-return' || i + '-roundtrip'
      )
    ) {
      this.httpService.openSnackBar('Please Fill the Empty Trailer Value');
      return;
    }
    const dropDownElement = document.getElementById('ftl-drop-down');
    if (dropDownElement) {
      dropDownElement.style.display = 'none';
    }
    this.displayedCol.push(i + '-inbound', i + '-return', i + '-roundtrip');
    this.destinCol.push(i, i + '-del');
    this.dbDataSource = this.dbDataSource.map((item: any) => ({
      ...item,
      [i + '-inbound']: null,
      [i + '-return']: null,
      [i + '-roundtrip']: null,
    }));
    this.dbDataSource = [...this.dbDataSource];
    this.appService.exportConversionEmitter.emit({
      data: this.dbDataSource,
      type: 'ftl',
    });

    this.rateTypeMapping[
      `${i.toUpperCase() + ' - SINGLE TRIP INBOUND km rate'}`
    ] = `${i}-inbound`;
    this.rateTypeMapping[
      `${i.toUpperCase() + ' - SINGLE TRIP RETURN km rate'}`
    ] = `${i}-return`;
    this.rateTypeMapping[
      `${i.toUpperCase() + ' - ROUNDTRIP km rate'}`
    ] = `${i}-roundtrip`;
    this.selectTruckType = this.selectTruckType.filter((value) => value !== i);
    this.appService.rateBackUpData[this.appService.selectedItem] =
      this.dbDataSource;
    this.onSave();
  }

  onDeleteTrailer(i: any) {
    let trailer = i.split('-')[0];
    this.selectTruckType.unshift(trailer);
    const dialogRef = this.dialog.open(DeleteWarningComponent, {
      disableClose: false,
      data: {
        header: 'Delete FTL Trailer',
        msg: `Are you sure you want to delete ${trailer.toUpperCase()} Trailer?`,
      },
    });
    dialogRef.afterClosed().subscribe((evt: any) => {
      if (evt.operation === 'confirm') {
        this.appService.onRAvalueChanged = true;
        let updatedData: any = this.dbDataSource.map((item: any) => {
          const {
            [(trailer + '-return') as string]: _,
            [(trailer + '-inbound') as string]: __,
            [(trailer + '-roundtrip') as string]: ___,
            ...rest
          }: { [key: string]: any } = item;
          return rest;
        });
        this.dbDataSource = [...updatedData];
        this.appService.rateBackUpData[this.appService.selectedItem] =
          this.dbDataSource;
        this.appService.exportConversionEmitter.emit({
          data: this.dbDataSource,
          type: 'ftl',
        });
        this.displayedCol = this.displayedCol.filter(
          (item) => !item.includes(trailer)
        );
        this.destinCol = this.destinCol.filter(
          (item) => !item.includes(trailer)
        );
        this.onSave();
      }
    });
  }
}
